// @mui
import { alpha } from '@mui/material/styles'
import { Shadows } from '@mui/material/styles/shadows'
//
import palette from './palette'

const LIGHT_MODE = palette.light.grey[500]
const DARK_MODE = '#000000'

/**
 * Three depths instead of Material's 25.
 *
 * Flat + a hairline border is the default; a shadow means "this floats above the
 * page". MUI's `Shadows` type is a 25-tuple and components index into it by
 * elevation, so the array keeps its length and the levels map onto three tokens
 * rather than being deleted:
 *
 *   0        none      — flat surfaces, cards, table rows
 *   1–4      raised    — resting cards that need separation from a tinted canvas
 *   5–12     floating  — menus, popovers, autocomplete, snackbars
 *   13–24    overlay   — dialogs, drawers, anything with a backdrop
 */
const createShadow = (color: string): Shadows => {
  const raised = `0 1px 2px ${alpha(color, 0.06)}, 0 2px 8px ${alpha(color, 0.06)}`
  const floating = `0 2px 4px ${alpha(color, 0.07)}, 0 8px 20px ${alpha(color, 0.09)}`
  const overlay = `0 4px 8px ${alpha(color, 0.08)}, 0 18px 40px ${alpha(color, 0.14)}`

  return [
    'none',
    raised,
    raised,
    raised,
    raised,
    floating,
    floating,
    floating,
    floating,
    floating,
    floating,
    floating,
    floating,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
    overlay,
  ]
}

const shadows = {
  light: createShadow(LIGHT_MODE),
  dark: createShadow(DARK_MODE),
}

export default shadows
